import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      URL Security Scanner v1.0 — Plataforma de Análise de Ameaças Web •{' '}
      Verificação baseada em múltiplas camadas de segurança •{' '}
      {new Date().getFullYear()}
    </footer>
  );
}
